// extracted by mini-css-extract-plugin
module.exports = {"name":"TeamCardAdmin_name__2Qr7x","title":"TeamCardAdmin_title__2d29J","content_container":"TeamCardAdmin_content_container__uomNC"};